import appConfig from "../../../src/app.config";
import Vue from "vue";

Vue.filter('currency', function (value) {
  return parseFloat(value).toLocaleString(appConfig.locale, { style: 'currency', currency: appConfig.currency })
})